import React from "react";
import { NavLink } from "react-router-dom";

class Title extends React.Component
{
    render()
    {
        return (
            <div className="fixedPos">

                    <div id="title">
                        Ekonkar Games
                        
                    </div>
                        <br></br>
                        <br></br>
                        
                    <div >
                            <NavLink style={{float:"left",marginLeft:'2em'}} className="navButtons" to ="/">Home</NavLink>
                            
                            <a style={{float:"right",marginRight:'2em'}} className="navButtons" href= '#' onClick={OpenContact} >Contact</a>


                    </div>
            </div>
        );
    }
}
export default Title;

function OpenContact()
{
    console.log('Clicked');
    window.open('mailto:developer.ekonkargames@gmail.com');
}